/**
 * main.ts - Application entry point.
 * Grabs the canvas and boots the Engine.
 */

import * as CANNON from "cannon";
(window as any).CANNON = CANNON;

import "babylonjs-loaders";
import { Engine } from "./core/Engine";

const canvas = document.getElementById("gameCanvas") as HTMLCanvasElement;
if (!canvas) throw new Error("Canvas element #gameCanvas not found");

// Boot the game
new Engine(canvas);
